import _styled2 from "styled-components";
import _styled from "styled-components";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import * as styles from './Skeleton.style';
export { SkeletonHeight, SkeletonColor } from './Skeleton.style';
export const Skeleton = _ref => {
  let {
    count,
    width,
    height,
    circle,
    color,
    lineHeight,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(_StyledDiv, _extends({
    $lineHeight: lineHeight,
    $count: count
  }, rest, {
    $_css: styles.base
  }), [...Array(count || 1).keys()].map(i => /*#__PURE__*/React.createElement(_StyledSpan, {
    key: `skeleton-${i}`,
    $width: width,
    $height: height,
    $circle: circle,
    $colorVariant: color || styles.SkeletonColor.LIGHT,
    $_css2: styles.skeleton
  }, "\u200C")));
};
export default Skeleton;
var _StyledDiv = _styled("div").withConfig({
  displayName: "Skeleton___StyledDiv",
  componentId: "sc-1idgz6h-0"
})(["", ""], p => p.$_css);
var _StyledSpan = _styled("span").withConfig({
  displayName: "Skeleton___StyledSpan",
  componentId: "sc-1idgz6h-1"
})(["", ""], p => p.$_css2);
//# sourceMappingURL=Skeleton.js.map